// extracted by extract-css-chunks-webpack-plugin
module.exports = {"card":"_2r-8U","cardTitle":"_8Ku8f","cardItem":"_29Y2n","cardItemTitle":"_2gEKJ","cardItemValue":"_2RYNY"};